/** OTP company credential providers (Domo, Ad Astra) — keys shared by save/load and UI catalog. */
export interface CompanyCredentialProvider {
  name: string;
  enabledKey: string;
  clientIdKey: string;
  clientSecretKey: string;
}

export const DOMO_CREDENTIALS: CompanyCredentialProvider = {
  name: 'domo',
  enabledKey: 'domoEnabled',
  clientIdKey: 'domoClientId',
  clientSecretKey: 'domoClientSecret',
};

export const ADASTRA_CREDENTIALS: CompanyCredentialProvider = {
  name: 'adastra',
  enabledKey: 'adastraEnabled',
  clientIdKey: 'adastraClientId',
  clientSecretKey: 'adastraClientSecret',
};

export const COMPANY_CREDENTIAL_PROVIDERS: readonly CompanyCredentialProvider[] =
  [DOMO_CREDENTIALS, ADASTRA_CREDENTIALS];
